import { ReactNode } from "react";
import classNames from "classnames";
import { Popover, Tooltip } from "antd";
import styles from "./DefectAreaOverlay.module.scss";
import DefectAreaLegend from "./DefectAreaLegend";
import { InfoIcon } from "./Icons";

interface OverlayControlsProps {
  roiSize: number;
  marginSize: number;
  roiVisible: boolean;
  maskVisible: boolean;
  onRoiToggle: () => void;
  onMaskToggle: () => void;
}

const OverlayChip = ({
  active,
  tooltip,
  swatchClassName,
  onClick,
  children,
}: {
  active: boolean;
  tooltip: string;
  swatchClassName: string;
  onClick: () => void;
  children: ReactNode;
}) => (
  <Tooltip title={tooltip}>
    <button
      type="button"
      aria-pressed={active}
      className={classNames(styles.overlayChip, { [styles.off]: !active })}
      onClick={onClick}
    >
      <span className={classNames(styles.swatch, swatchClassName)} />
      {children}
    </button>
  </Tooltip>
);

// Legend for the image overlays; each item also toggles its overlay
const OverlayControls = ({
  roiSize,
  marginSize,
  roiVisible,
  maskVisible,
  onRoiToggle,
  onMaskToggle,
}: OverlayControlsProps) => (
  <div className={styles.overlayControls}>
    <OverlayChip
      active={roiVisible}
      tooltip={
        roiVisible
          ? "Hide the classification area marker"
          : "Show the classification area marker"
      }
      swatchClassName={styles.swatchRoi}
      onClick={onRoiToggle}
    >
      Classification area {roiSize.toLocaleString()} px
    </OverlayChip>
    <OverlayChip
      active={maskVisible}
      tooltip={
        maskVisible
          ? "Stop dimming the area outside the context box (M)"
          : "Dim the area outside the context box (M)"
      }
      swatchClassName={styles.swatchMargin}
      onClick={onMaskToggle}
    >
      Context {marginSize.toLocaleString()} px
    </OverlayChip>
    <Popover
      content={<DefectAreaLegend roiSize={roiSize} marginSize={marginSize} />}
      placement="bottomRight"
    >
      <button
        type="button"
        className={styles.overlayInfo}
        aria-label="What do the overlays mean?"
      >
        <InfoIcon />
      </button>
    </Popover>
  </div>
);

export default OverlayControls;
